import React from 'react'
import ReactDOM from 'react-dom'

const traverseElementRecursively = (elem, func) => {
  const { children } = elem

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < children.length; i++) {
    const nextChild = children[i]

    if (func(nextChild) === true) {
      return true
    }

    if (traverseElementRecursively(nextChild, func)) {
      return true
    }
  }

  return false
}

class SemanticDropdownAutoFocus extends React.Component {
  componentDidMount() {
    const domNode = ReactDOM.findDOMNode(this) // eslint-disable-line

    if (this.props.autoFocus) {
      traverseElementRecursively(domNode, (nextElem) => {
        if (nextElem.nodeName === 'INPUT') {
          nextElem.focus()

          return true
        }
      })
    }
  }

  render() {
    return this.props.children
  }
}

SemanticDropdownAutoFocus.defaultProps = {
  autoFocus: true,
}

export default SemanticDropdownAutoFocus
